import { render, staticRenderFns } from "./productResume.html?vue&type=template&id=0d997f1b&scoped=true&"
import script from "./productResume.js?vue&type=script&lang=js&"
export * from "./productResume.js?vue&type=script&lang=js&"
import style0 from "./productResume.scss?vue&type=style&index=0&id=0d997f1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d997f1b",
  null
  
)

export default component.exports